<template>
  <loading-page
    v-if="fetchingApiKey"
    full
  />
  <api-key-form v-else />
</template>

<script>
import ApiKeyForm from './ApiKeyForm.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'ApiKeyNew',
  components: {
    ApiKeyForm,
  },
  computed: {
    fetchingApiKey() {
      return this.$store.state.apiKeys.fetchingApiKey
    },
  },
  created() {
    this.$store.dispatch('apiKeys/fetchApiKey', 0)
      .catch(err => redirectError(err))
  },
}
</script>

<style>

</style>
